import React from 'react';
import MailchimpSubscribe from "react-mailchimp-subscribe"

import mailchimpStyles from './mailchimp.module.sass';

const url = "//trufflepigs.us20.list-manage.com/subscribe/post?u=64d1417a1fc9ab59a2ebcb12e&id=fe90c07f0a";

const CustomForm = ({status, message, onValidated, addClass}) => {
  let email
  
  const submit = () =>
    email &&
    email.value.indexOf ('@') > -1 &&
    onValidated ({
      EMAIL: email.value
    });

  return (
    <div className={addClass}>

      <div className={mailchimpStyles.form}>
        <input
          className={mailchimpStyles.email}
          ref={node => (email = node)}
          type="email"
          placeholder="Your email"
        />
        <button className={mailchimpStyles.button} type="submit" onClick={submit}>
          Submit
        </button>
      </div>

      <div className={mailchimpStyles.response}>
        {status === "sending" && <strong className={mailchimpStyles.response_sending}>Sending</strong>}
        {status === "error" && <strong className={mailchimpStyles.response_error} dangerouslySetInnerHTML={{ __html: message }} />}
        {status === "success" && (
          <strong className={mailchimpStyles.response_subscribed}>
            <span role="img" aria-label="You have successfully subscribed to the Truffle Pigs newsletter">🐷</span>
            &nbsp;Subscribed&nbsp;
            <span role="img" aria-label="You have successfully subscribed to the Truffle Pigs newsletter">🐷</span>
          </strong>
          )
        }
      </div>

    </div>
  );
};

export default props => (
  <MailchimpSubscribe
    url={url}
    className={mailchimpStyles.mailchimp}
    render={({ subscribe, status, message }) => (
      <div className={mailchimpStyles.mailchimp}>
        <div className={[mailchimpStyles.content, "center"].join(' ')}>
          <h3 className={[mailchimpStyles.title, "center"].join(' ')}>{props.mailchimp.heading}</h3>
          <p className={[mailchimpStyles.text, "center"].join(' ')}>{props.mailchimp.text}</p>
        </div>
        <CustomForm
          addClass={mailchimpStyles.custom}
          status={status}
          message={message}
          onValidated={formData => subscribe(formData)}
        />
      </div>
    )}
  />
)